import { IUser } from 'api/types/_user';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { STATUS_USER_OPTIONS } from 'helpers/constans';
import { ROLES_FOR_APP, isHavePermissionRole } from 'helpers/role';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import TableContainer from "../../../components/Common/TableContainer";
import { deleteUser, getUsers as onGetUsers, putUser, getAllPartners, getAllCategory } from "../../../store/thunks";
import UserForm from './UserForm';
import { Option } from 'api/types/_public';
import DropdownStatus from 'components/Common/DropdownStatus';
import { filterMediaOptions, formatNumberWithCommas } from 'helpers/format';
import DropdownOption from 'components/Common/DropdownOption';
import { ICategory } from 'api/types/_category';
export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'id';

registerLocale('en', en);
registerLocale('ko', ko);


const UserList = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const STATUS_USER_OPTIONS_LANG: any = STATUS_USER_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  const STATUS_ALLOWED_BOOSTING_NEWS_OPTIONS_LANG: any = [{ value: '1', label: 'Allowed' }, { value: '0', label: 'Not Allowed' }]?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    name: withDefault(StringParam, ''),
    email: withDefault(StringParam, ''),
    company: withDefault(StringParam, ''),
    media_id: withDefault(StringParam, ''),
    is_active: withDefault(StringParam, ''),
    is_boosting_news_allowed: withDefault(StringParam, ''),
  });

  const [partners, setPartners] = useState<{ label: string, value: string, name: string }[]>([]);

  const [categories, setCategories] = useState<ICategory[]>([]);

  const [nameSearch, setNameSearch] = useState<string>(query?.name || "");
  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");
  const [companySearch, setCompanySearch] = useState<string>(query?.company || "");
  const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_USER_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.is_active)) || null);

  const [allowedSearch, setAllowedSearch] = useState<Option | null>(STATUS_USER_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.is_boosting_news_allowed)) || null);

  const [mediaSearch, setMediaSearch] = useState<Option | null>(partners?.find((item) => String(item?.value) === String(query?.media_id)) || null);

  const [userEdit, setUserEdit] = useState<IUser & { isCopy?: boolean } | null>(null);

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [initialValuesDefault, setInitialValuesDefault] = useState<IUser | null>(null);

  const [userCategories, setUserCategories] = useState<any[] | null>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.User;

  const UserProperties = createSelector(
    selectLayoutState,
    (state) => ({
      users: state.users,
      isUserSuccess: state.isUserSuccess,
      isUserLoading: state.isUserLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { users, error, isUserLoading } = useSelector(UserProperties);


  useEffect(() => {
    dispatch(onGetUsers(query));
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      name: nameSearch || '',
      email: emailSearch || '',
      company: companySearch || '',
      media_id: mediaSearch?.value || '',
      is_active: statusSearch?.value,
      is_boosting_news_allowed: allowedSearch?.value,
      page: 1,
      time_request: + new Date()
    });
  };

  const resetData = () => {
    setQuery({
      name: '',
      email: '',
      company: '',
      media_id: '',
      is_active: '',
      is_boosting_news_allowed: '',
      sort_by: TYPE_SELECT_DEFAULT,
      time_request: + new Date(),
      page: 1,
    }, "push")
    setNameSearch((_prev) => "");
    setEmailSearch((_prev) => "");
    setCompanySearch((_prev) => "");
    setStatusSearch(null);
    setAllowedSearch(null);
    setMediaSearch((_prev) => null);
  };


  // Begin::Update User
  const onCloseClick = () => {
    setUserEdit((_prev) => null);
    setIsOpen((_prev) => false)
  }

  const triggerRefresh = () => {
    onCloseClick();
    dispatch(onGetUsers(query));
  }
  //End::Update User

  // Begin::Delete
  const handleConfirmDelete = (item: IUser) => {
    setInitialValuesDefault((_prev) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!(initialValuesDefault?.id)) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await deleteUser(initialValuesDefault?.id);
      if (response?.code === 200) {
        dispatch(onGetUsers(query));
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev) => null);
    setIsConfirm((_prev) => false);
  }
  // End::Delete


  const openUserCategories = (_categories: any = []) => {
    setUserCategories((_prev: any) => _categories);
  };

  const closeUserCategories = () => {
    setUserCategories((_prev: any) => null);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('ID'),
        accessor: "id",
        filterable: true,
        sortable: false,
        thWidth: 50,
        Cell: (cell: any) => (
          <>
            <span style={{ minWidth: '50px' }}>{cell?.value}</span>
          </>
        ),
      },
      {
        Header: t('Status'),
        accessor: "is_active",
        filterable: false,
        sortable: false,
        thClass: 'text-center',
        thWidth: 100,
        Cell: (cell: any) => {
          return (
            <div className="text-center" style={{ minWidth: '80px' }}>
              <span className={`rounded-pill badge bg-${['danger', 'success'][cell?.value] || 'secondary'}`}>{STATUS_USER_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(cell?.value))?.label}</span>
            </div>
          );
        }
      },
      {
        Header: t('Name'),
        accessor: "name",
        filterable: true,
        sortable: false,
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }}>
              {item?.name || '-'}
            </div>
          </>)
        },
      },
      {
        Header: t('Email'),
        accessor: "email",
        filterable: true,
        sortable: false,
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }}>{cell?.value || '-'}</div>
          </>)
        },
      },
      {
        Header: t('Company'),
        accessor: "company",
        filterable: true,
        sortable: false,
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }}>{cell?.value || '-'}</div>
          </>)
        },
      },
      {
        Header: t('Media'),
        accessor: "media",
        filterable: true,
        sortable: false,
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }}>{item?.configs?.media?.name || '-'}</div>
          </>)
        },
      },
      {
        Header: t('Boosting News'),
        accessor: "boosting_news_flg",
        filterable: true,
        sortable: false,
        thWidth: 160,
        thClass: 'text-center',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }} className="text-center">
              <span className={`rounded-pill badge bg-${item?.configs?.boosting_news_flg ? 'success' : 'danger'} fs-12 me-2`}>
                {item?.configs?.boosting_news_flg ? t('Allowed') : t('Not Allowed')}
              </span>
            </div>
          </>)
        },
      },
      {
        Header: t('Boosting Category'),
        accessor: "categories",
        filterable: true,
        sortable: false,
        thWidth: 300,
        thClass: 'text-start',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px', maxWidth: '280px' }} className="d-flex flex-wrap justify-content-start align-items-end gap-2">
              {((item?.categories || [])?.length === 0) && <>-</>}
              {(item?.categories || [])?.map((_c: any, index: number) => (
                (index < 10) ? <span className="rounded-pill badge bg-primary-subtle text-primary fs-12" key={_c?.id}>{_c?.name || ''}</span> : <></>
              ))}
              {
                (item?.categories || [])?.length > 10 && <span className="link-primary d-inline cursor-pointer fs-12" onClick={() => openUserCategories(item?.categories || [])}>...{t('Show more')}</span>
              }
            </div>
          </>)
        },
      },
      {
        Header: t('Phone'),
        accessor: "phone_number",
        filterable: true,
        sortable: false,
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }}>{cell?.value || '-'}</div>
          </>)
        },
      },
      {
        Header: t('Domain'),
        accessor: "domain",
        filterable: true,
        sortable: false,
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }}>{cell?.value || '-'}</div>
          </>)
        },
      },
      {
        Header: t('Usage restrictions'),
        accessor: "news_daily_limit",
        filterable: true,
        sortable: false,
        description: t('Daily article limit'),
        thClass: 'text-end',
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '140px' }} className="text-end pe-3">{formatNumberWithCommas(item?.configs?.news_daily_limit)}</div>
          </>)
        },
      },
      {
        Header: t('Number Of Login'),
        accessor: "login_count",
        filterable: true,
        sortable: true,
        thWidth: 160,
        thClass: 'text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '140px' }}>
              {formatNumberWithCommas(cell?.value)}
            </div>
          )
        },
      },
      {
        Header: t('Last Login Time'),
        accessor: "last_login_at",
        filterable: true,
        sortable: true,
        thWidth: 150,
        thClass: 'text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '130px' }}>
              <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Created at'),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 110,
        thClass: 'text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Updated at'),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 110,
        thClass: 'text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Action'),
        thClass: 'text-center',
        thWidth: 100,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '70px' }}>
              {isHavePermissionRole(ROLES_FOR_APP.USER_UPDATE, userPermissions) && <TooltipCustom
                title={t('Button Update User')}
                id={`update-us-${item?.id}`}
              >
                <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
                  <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                    onClick={(e) => { e.preventDefault(); setUserEdit((prev) => item) }}
                  >
                    <i className="ri-pencil-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>}
              {isHavePermissionRole(ROLES_FOR_APP.USER_DELETE, userPermissions) && (
                <TooltipCustom
                  title={t('Button Delete User')}
                  id={`detail-cp-${item?.id}`}
                >
                  <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                    <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                      onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                    >
                      <i className="ri-delete-bin-3-fill align-bottom"></i>
                    </Link>
                  </li>
                </TooltipCustom>
              )}
            </ul>
          );
        },
      },
    ],
    [i18n?.language, query, userPermissions]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy });
    });
  }, []);

  const handleCallAllOption = async () => {
    try {
      const [res1, res2]: any = await Promise.all([getAllPartners({}), getAllCategory({})])
      const _list_partner = (res1?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name, is_partner: ml?.is_partner, partner_codes: ml?.partner_codes, partner_reporters: ml?.partner_reporters }));
      setPartners((_prev: any) => _list_partner);
      setCategories((_prev) => res2?.data || []);

      if (query?.media_id) {
        const _val = (_list_partner)?.find((s: any) => String(s?.value) === String(query?.media_id));
        setMediaSearch(_val);
      }

    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Home')} - ${t('User Management')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('User Management')} pageTitle={t('Home')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.USER_LIST, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-5 con-sm-6">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t('Total')}:</span>
                            <CountUp
                              start={0}
                              end={users?.pagination?.total || 0}
                              duration={1}
                              className="text-primary"
                            />
                          </h5>
                        </div>
                      </div>
                      <div className="col-7 con-sm-6 text-end">
                        {isHavePermissionRole(ROLES_FOR_APP.USER_CREATE, userPermissions) && (<div className="col-sm-auto">
                          <div>
                            <button
                              type="button"
                              className="btn btn-success add-btn rounded-pill"
                              id="create-btn"
                              onClick={() => setIsOpen((_prev) => true)}
                            >
                              <i className="ri-add-line align-bottom me-1"></i>
                              {t('Button Create User')}
                            </button>
                          </div>
                        </div>)}
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                    <Row className="g-4 align-items-center mt-0">
                      <Col sm={6} md={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Name')} isShow={!!nameSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t('Name')}...`}
                            value={nameSearch}
                            onChange={(e) => setNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col sm={6} md={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Email')} isShow={!!emailSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t('Email')}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={6} md={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Company')} isShow={!!companySearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t('Company')}...`}
                            value={companySearch}
                            onChange={(e) => setCompanySearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={6} md={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Media')} isShow={true}>
                          <DropdownOption
                            name="media"
                            dataList={filterMediaOptions(partners || [])}
                            placeholder={`${t("Media")}...`}
                            className="dropdown-status-rounded z-hight"
                            classNamePrefix="name-prefix"
                            initialValue={mediaSearch || null}
                            onChangeSelect={(e: any) => setMediaSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t('All'), value: '' }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col sm={6} md={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Boosting News')} isShow={true}>
                          <DropdownStatus
                            name="allowed"
                            dataList={STATUS_ALLOWED_BOOSTING_NEWS_OPTIONS_LANG || []}
                            placeholder={`${t("Boosting News")}...`}
                            className="dropdown-status-rounded z-hight"
                            classNamePrefix="name-prefix"
                            initialValue={allowedSearch || null}
                            onChangeSelect={(e: any) => setAllowedSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t('All'), value: '' }}
                            colors={['danger', 'success']}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={6} md={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Status')} isShow={true}>
                          <DropdownStatus
                            name="status"
                            dataList={STATUS_USER_OPTIONS_LANG || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded z-hight"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch || null}
                            onChangeSelect={(e: any) => setStatusSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t('All'), value: '' }}
                            colors={['danger', 'success']}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col sm={12} md={12} xl={12} xxl={12} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-md-end mt-3">
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-2 "
                            onClick={searchData}
                            disabled={isUserLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t('Button Search')}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t('Button Reset')}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-3">
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle sticky-table-user"
                      theadClass="table-light"
                      columns={columns}
                      data={users?.list?.length ? users?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={users?.pagination?.total}
                      customPageCount={Math.ceil(Number(users?.pagination?.total) / Number(users?.pagination?.limit))}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isUserLoading}
                    />
                  </CardBody>
                </Card>
              </Col>
            )}</Row>
        </Container>
        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />
        <Modal
          isOpen={!!userEdit?.id || isOpen}
          centered={true}
          size="lg"
          scrollable={true}
        >
          <ModalHeader toggle={onCloseClick}>
            <>{!!(userEdit?.id) ? t("Button Update User") : t("Button Create User")}</>  <>{(userEdit?.id) && (' - ' + (userEdit?.name || '') || '')}</>
          </ModalHeader>
          <ModalBody className="pt-2">
            <div style={{ minHeight: "calc(100dvh - 300px)" }}>
              <UserForm
                isModal={true}
                id={String(userEdit?.id || '')}
                isCopy={!!(userEdit?.isCopy)}
                partners={partners}
                categories={categories}
                triggerRefresh={triggerRefresh}

              />
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={!!userCategories}
          centered={true}
          size="lg"
          scrollable={true}
        >
          <ModalHeader toggle={closeUserCategories}>
            {t("Boosting Category")}
          </ModalHeader>
          <ModalBody className="pt-2">
            <div>
              <Col sm={12} md={12} xl={12} xxl={12}>
                <div>
                  <div className="d-flex gap-2 flex-wrap">
                    {(userCategories || [])?.map((item: any) => (
                      <button type="button" className="btn px-3 px-md-4 py-btn-section bg-primary-subtle text-primary" key={item?.id}>
                        {item?.name}
                      </button>
                    ))}
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
          <ModalFooter>
            <Col sm={12} >
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center"
                  type="button"
                  onClick={closeUserCategories}
                  style={{ width: '90px' }}
                >
                  <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                </button>
              </div>
            </Col>
          </ModalFooter>
        </Modal>

        <ModalConfirm
          header={t('Button Delete User')}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />
      </div >
    </React.Fragment >
  );
};

export default UserList;